import React, { useEffect, useState } from "react";
import {
  Button,
  Breadcrumb,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Row,
  Stack,
  FormSelect,
  Modal,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";

import PubSub from "pubsub-js";
import Select from "react-select";
import { regExPattern } from "../../utils/regExPattern";
import { validationMessages } from "../../utils/messages";
import { ROUTES } from "../../constants/webRouting";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import CityState from "../../constants/CityState.json";
import {
  formatDate,
  formatDateForView,
  getUserDetails,
  formatDateForCreatedDate,
} from "../../utils/helper";
import * as Constant from "../../constants/CONSTANT";
import "./Order.css";
import { handleUppercaseChange } from "../common/UpperCaseMethod";
import PERMISSIONS from "../../constants/permissions";
import { set } from "react-hook-form";

const OrderEdit = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [showLostModal, setShowLostModal] = useState(false);
  // Define initial errors i.e. required field and their message
  const initialErrors = {
    offer_id: { message: validationMessages.offerName.required },
    phone: { message: validationMessages.phone.required },
    owner_ids: { message: validationMessages.ownerId.required },
    // handover_date: { message: validationMessages.handoverDate.required },
    // warranty_start_date: { message: validationMessages.warrantStartDate.required },
  };
  const userInfo = getUserDetails();
  // Imran Khan Added 15/01/2026 qty offer defult
  const initialValues = {
    order_date: new Date(),
    owner_ids: [{ value: userInfo?.id, label: userInfo?.username }],
    is_gst: "Yes",
    city: "Jaipur",
    // qty: location.state?.number_of_units || 1,
    // qty: 1
  };
  //Imran Khan 20/01/2026

  const handleShowLostOrder = () => {
    setLostOrderData({
      lost_date: order?.lost_date || new Date(),
      lost_remark: order?.lost_remark || "",
      lost_by_reason: order?.lost_by_reason || "",
    });
    setShow(true);
  };

  // order state
  const [order, setOrder] = useState({
    ...initialValues,
    ...(location.state || {}),
    qty: location.state?.number_of_units ?? 1,
  });

  const [lostOrderData, setLostOrderData] = useState({
    lost_date: order?.lost_date || new Date(),
    lost_remark: "",
    lost_by_reason: "",
  });

  // Handle City & state values
  const [states, setStates] = useState([
    ...new Set(CityState.map((item) => item.state)),
  ]);

  const [segmentOptions, setSegmentOptions] = useState(Constant?.SegmentOptions);//Added by shahir hussain for segment type field 02-02-2025

  //Imran Khan Added 20/01/2026
  const handleLostOrderChange = (e) => {
    const { name, value } = e.target;

    setLostOrderData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //Imran Khan 20/01/2026
  const handleLostOrderSave = () => {
    setOrder((prev) => ({
      ...prev,
      lost_date: lostOrderData.lost_date,
      lost_remark: lostOrderData.lost_remark,
      lost_by_reason: lostOrderData.lost_by_reason,
    }));
    handleClose();
  };

  //Imran khan Added Enquiry Lost Modal Code Here 07-01-2026
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setLostOrderData({
      //lost_date: null,
      lost_remark: "",
      lost_by_reason: "",
    });
    setShow(false);
  };

  const handleShow = () => setShow(true);
  //End Here Imran khan Added Enquiry Lost Modal Code Here 07-01-2026
  //errors state
  const [errors, setErrors] = useState(!location.state ? initialErrors : {});
  useEffect(() => {
    console.log("errors", errors);
  }, [errors]);

  // validation state
  const [validated, setValidated] = useState(false);

  // offer state
  const [offers, setOffers] = useState([]);

  // lead state
  const [leads, setLeads] = useState([]);

  // assign users state
  const [assignUsers, setAssignUsers] = useState([]);
  useEffect(() => {
    async function init() {
      if (
        [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_OFFER].some((permission) => {
          return userInfo?.permissions?.map((p) => p.name).includes(permission);
        })
      ) {
        let OfferRecord = null;
        if (order.id) {
          OfferRecord = await fuziElevatorsApi.fetchOfferById(order.offer_id);
        }
        const fetchedOffers = await fuziElevatorsApi.fetchOffersForOrder();
        console.log("fetchedOffers", fetchedOffers);
        if (Array.isArray(fetchedOffers)) {
          const resultedOffer = fetchedOffers?.map((fetchedOffer) => ({
            id: fetchedOffer?.id,
            name: `${fetchedOffer?.offer_name_label || ""}`,
            offerData: fetchedOffer,
          }));
          OfferRecord &&
            resultedOffer.push({
              id: order?.offer_id,
              name: order?.offer_name_label,
              offerData: OfferRecord,
            });
          setOffers([...resultedOffer]);
        } else {
          OfferRecord &&
            setOffers([
              {
                id: order?.offer_id,
                name: order?.offer_name_label,
                offerData: OfferRecord,
              },
            ]);
        }
      }

      if (
        [PERMISSIONS.VIEW_ALL, PERMISSIONS.VIEW_LEAD].some((permission) => {
          return userInfo?.permissions?.map((p) => p.name).includes(permission);
        })
      ) {
        const fetchedLeads = await fuziElevatorsApi.fetchLeads();
        console.log("fetchedLeads", fetchedLeads);
        Array.isArray(fetchedLeads) &&
          setLeads(
            fetchedLeads?.map((fetchedLead) => ({
              id: fetchedLead?.id,
              name: `${fetchedLead?.lead_name || ""}`,
            })),
          );
      }

      if (
        [PERMISSIONS.VIEW_ALL, PERMISSIONS.VIEW_USER].some((permission) => {
          return userInfo?.permissions?.map((p) => p.name).includes(permission);
        })
      ) {
        const resultedUsers = await fuziElevatorsApi.fetchUsers();
        resultedUsers &&
          Array.isArray(resultedUsers) &&
          setAssignUsers(resultedUsers);
      }
    }
    init();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(e.target.value);
    if (name == "offer_id") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.offerName.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "order_status") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.status.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
      // Imran Khan  Update Enquiry Lost Modal Code Here 07-01-2026
      if (name === "order_status" && value === "Order Lost") {
        setOrder((prev) => ({
          ...prev,
          is_lost: true,
          lost_date: new Date(),
          [name]: value,
        }));

        handleShowLostOrder();
        setValidated(true);
      }
    }
    // End Here Imran Khan  Update Enquiry Lost Modal Code Here 07-01-2026
    else if (name == "email") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.email.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name === "phone") {
      if (value === "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.phone.required },
        }));
      } else if (e?.target?.pattern && !RegExp(e.target.pattern).test(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.phone.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "whatsapp_no") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.whatsappNumber.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "owner_ids") {
      if (!value?.length) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.ownerId.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }

    // else if (name == "handover_date") {
    //     if (value == "") {
    //         setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.handoverDate.required } }));
    //     } else {
    //         setErrors((prev) => {
    //             delete prev[name];
    //             return { ...prev };
    //         });
    //     }
    // }

    // else if (name == "warranty_start_date") {
    //     if (value == "") {
    //         setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.warrantStartDate.required } }));
    //     } else {
    //         setErrors((prev) => {
    //             delete prev[name];
    //             return { ...prev };
    //         });
    //     }
    // }
    else if (name == "qty") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.quantity.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "pincode") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.pinCode.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name === "segment") {//Added by shahir hussain for segment type field 02-02-2025
      const values = Array.isArray(value)
        ? value?.map((item) => item?.value)
        : [];

      const segmentString = values.join(",");

      setOrder((prev) => ({
        ...prev,
        segment: segmentString,
      }));

      // validation
      // if (values?.length === 0) {
      //   setErrors((prev) => ({
      //     ...prev,
      //     segment: { message: validationMessages.segment.required },
      //   }));
      // } else {
      //   setErrors((prev) => {
      //     delete prev.segment;
      //     return { ...prev };
      //   });
      // }

      setValidated(true);
      return;
    }
    // else if (name == "country") {
    //     if (value != "" && e?.target?.pattern && (!RegExp(e.target.pattern).test(value))) {
    //         setErrors((prev) => ({ ...prev, [name]: { message: validationMessages.country.invalid } }));
    //     } else {
    //         setErrors((prev) => {
    //             delete prev[name];
    //             return { ...prev };
    //         });
    //     }
    // }
    setValidated(true);
    setOrder((prev) => ({ ...prev, [name]: value }));

    // Material order default date functionality
    if (name == "scaffolding_material_status")
      if (value == "Complete")
        order.scaffolding_material_status_date = new Date();
    if (name == "customer_white_wash_status")
      if (value == "Complete")
        order.customer_white_wash_status_date = new Date();
    if (name == "customer_shaft_lighting_status")
      if (value == "Complete")
        order.customer_shaft_lighting_status_date = new Date();
    if (name == "customer_3phase_earthing_status")
      if (value == "Complete")
        order.customer_3phase_earthing_status_date = new Date();
    if (name == "door_supplied_status")
      if (value == "Complete") order.door_supplied_status_date = new Date();
    if (name == "motor_supplied_status")
      if (value == "Complete") order.motor_supplied_status_date = new Date();
    if (name == "cabin_status")
      if (value == "Complete") order.cabin_status_date = new Date();
    if (name == "control_panel_status")
      if (value == "Complete") order.control_panel_status_date = new Date();
    if (name == "customer_archive_work_status")
      if (value == "Complete")
        order.customer_archive_work_status_date = new Date();
    if (name == "material_ready_status")
      if (value == "Complete") order.material_ready_status_date = new Date();
    if (name == "admin_approval_status")
      if (value == "Complete") order.admin_approval_status_date = new Date();
    if (name == "commissioning_status")
      if (value == "Complete") order.commissioning_status_date = new Date();
  };

  // field validators
  const checkRequiredFields = () => {
    let isError = false;

    if (order?.offer_id) {
      if (order?.offer_id == "") {
        setErrors((prev) => ({
          ...prev,
          offer_id: { message: validationMessages.offerName.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["offer_id"];
          return { ...prev };
        });
      }
    }

    if (order?.order_status) {
      if (order?.order_status == "") {
        setErrors((prev) => ({
          ...prev,
          order_status: { message: validationMessages.status.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["order_status"];
          return { ...prev };
        });
      }
    }

    if (order?.email) {
      if (
        order?.email != "" &&
        regExPattern?.email &&
        !RegExp(regExPattern.email).test(order.email)
      ) {
        setErrors((prev) => ({
          ...prev,
          email: { message: "Please provide Valid Email." },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["email"];
          return { ...prev };
        });
      }
    }

    if (order?.phone) {
      if (order?.phone == "") {
        setErrors((prev) => ({
          ...prev,
          phone: { message: "Please provide phone." },
        }));
        isError = true;
      } else if (
        regExPattern?.phone &&
        !RegExp(regExPattern.phone).test(order.phone)
      ) {
        setErrors((prev) => ({
          ...prev,
          phone: { message: "Please provide Valid phone." },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["phone"];
          return { ...prev };
        });
      }
    }

    if (order?.whatsapp_no) {
      if (
        order?.whatsapp_no != "" &&
        regExPattern?.phone &&
        !RegExp(regExPattern.phone).test(order.whatsapp_no)
      ) {
        setErrors((prev) => ({
          ...prev,
          whatsapp_no: { message: "Please provide Valid whatsapp number." },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["whatsapp_no"];
          return { ...prev };
        });
      }
    }

    if (order?.owner_ids) {
      if (!order?.owner_ids?.length) {
        setErrors((prev) => ({
          ...prev,
          owner_ids: { message: validationMessages.ownerId.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["owner_ids"];
          return { ...prev };
        });
      }
    }

    // if (order?.handover_date) {

    //     if (order?.handover_date == "") {
    //         setErrors((prev) => ({ ...prev, 'handover_date': { message: validationMessages.handoverDate.required } }));
    //         isError = true;
    //     } else {
    //         setErrors((prev) => {
    //             delete prev['handover_date'];
    //             return { ...prev };
    //         });
    //     }

    // }

    // if (order?.warranty_start_date) {

    //     if (order?.warranty_start_date == "") {
    //         setErrors((prev) => ({ ...prev, 'warranty_start_date': { message: validationMessages.warrantStartDate.required } }));
    //         isError = true;
    //     } else {
    //         setErrors((prev) => {
    //             delete prev['warranty_start_date'];
    //             return { ...prev };
    //         });
    //     }

    // }

    if (order?.qty) {
      if (
        order?.qty != "" &&
        regExPattern?.quantity &&
        !RegExp(regExPattern.quantity).test(order.qty)
      ) {
        setErrors((prev) => ({
          ...prev,
          qty: { message: validationMessages.quantity.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["qty"];
          return { ...prev };
        });
      }
    }

    if (order?.pincode) {
      if (
        order?.pincode != "" &&
        regExPattern?.pinCode &&
        !RegExp(regExPattern.pinCode).test(order.pincode)
      ) {
        setErrors((prev) => ({
          ...prev,
          pincode: { message: "Please provide valid pincode." },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["pincode"];
          return { ...prev };
        });
      }
    }

    // handle errors for required fields
    if (!order?.offer_id) {
      setErrors((prev) => ({
        ...prev,
        offer_id: { message: validationMessages.offerName.required },
      }));
      isError = true;
    }
    if (!order?.owner_ids?.length) {
      setErrors((prev) => ({
        ...prev,
        owner_ids: { message: validationMessages.ownerId.required },
      }));
      isError = true;
    }
    // if (!order?.handover_date) {
    //     setErrors((prev) => ({ ...prev, 'handover_date': { message: validationMessages.handoverDate.required } }));
    //     isError = true;
    // }
    // if (!order?.warranty_start_date) {
    //     setErrors((prev) => ({ ...prev, 'warranty_start_date': { message: validationMessages.warrantStartDate.required } }));
    //     isError = true;
    // }
    if (!order?.phone) {
      setErrors((prev) => ({
        ...prev,
        phone: { message: validationMessages.phone.required },
      }));
      isError = true;
    }

    if (!order?.order_status) {
      setErrors((prev) => ({
        ...prev,
        order_status: { message: validationMessages.status.required },
      }));
      isError = true;
    }

    console.log("isError", isError);

    return isError;
  };

  // onSubmit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("order", order);
    console.log("errors", errors);
    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    console.log("order", order);
    console.log("errors", errors);

    if (Object?.keys(errors)?.length != 0) {
      setValidated(true);
      return;
    }

    const record = { ...order };

    // handle date format
    if (record?.order_date) {
      record.order_date = formatDate(record?.order_date);
    }
    // delete unnecessary fields
    delete record.offer_name_label;
    delete record.owner_name;
    delete record.lead_name;

    // handle numeric fields
    record.order_amount = record?.order_amount == "" ? 0 : record?.order_amount;
    record.passenger_capacity =
      record?.passenger_capacity == "" ? 0 : record?.passenger_capacity;
    record.total_stops = record?.total_stops == "" ? 0 : record?.total_stops;
    record.floor_counts = record?.floor_counts == "" ? 0 : record?.floor_counts;

    // handle date fields
    record.order_date = record?.order_date == "" ? null : record?.order_date;
    record.scaffolding_material_status_date =
      record?.scaffolding_material_status_date == ""
        ? null
        : record.scaffolding_material_status_date;
    record.customer_white_wash_status_date =
      record?.customer_white_wash_status_date == ""
        ? null
        : record?.customer_white_wash_status_date;
    record.customer_shaft_lighting_status_date =
      record?.customer_shaft_lighting_status_date == ""
        ? null
        : record?.customer_shaft_lighting_status_date;
    record.customer_3phase_earthing_status_date =
      record?.customer_3phase_earthing_status_date == ""
        ? null
        : record?.customer_3phase_earthing_status_date;
    record.door_supplied_status_date =
      record?.door_supplied_status_date == ""
        ? null
        : record?.door_supplied_status_date;
    record.motor_supplied_status_date =
      record?.motor_supplied_status_date == ""
        ? null
        : record?.motor_supplied_status_date;
    record.cabin_status_date =
      record?.cabin_status_date == "" ? null : record?.cabin_status_date;
    record.control_panel_status_date =
      record?.control_panel_status_date == ""
        ? null
        : record?.control_panel_status_date;
    record.customer_archive_work_status_date =
      record?.customer_archive_work_status_date == ""
        ? null
        : record?.customer_archive_work_status_date;
    record.material_ready_status_date =
      record?.material_ready_status_date == ""
        ? null
        : record?.material_ready_status_date;
    record.admin_approval_status_date =
      record?.admin_approval_status_date == ""
        ? null
        : record?.admin_approval_status_date;
    record.commissioning_status_date =
      record?.commissioning_status_date == ""
        ? null
        : record?.commissioning_status_date;
    record.handover_date =
      record?.handover_date == "" ? null : record?.handover_date;
    record.warranty_start_date =
      record?.warranty_start_date == "" ? null : record?.warranty_start_date;
    record.warranty_end_date =
      record?.warranty_end_date == "" ? null : record?.warranty_end_date;
    record.lost_date = record?.lost_date == "" ? null : record?.lost_date;

    // Handle date fields
    if (record?.warranty_start_date)
      record.warranty_start_date = formatDate(record?.warranty_start_date);
    if (record?.warranty_end_date)
      record.warranty_end_date = formatDate(record?.warranty_end_date);
    if (record?.handover_date)
      record.handover_date = formatDate(record?.handover_date);

    if (record?.gad_allowed_to)
      record.gad_allowed_to = formatDate(record?.gad_allowed_to);
    if (record?.gad_finalized_on)
      record.gad_finalized_on = formatDate(record?.gad_finalized_on);

    if (record?.scaffolding_material_status_date)
      record.scaffolding_material_status_date = formatDate(
        record.scaffolding_material_status_date,
      );
    if (record?.customer_white_wash_status_date)
      record.customer_white_wash_status_date = formatDate(
        record.customer_white_wash_status_date,
      );
    if (record?.customer_shaft_lighting_status_date)
      record.customer_shaft_lighting_status_date = formatDate(
        record?.customer_shaft_lighting_status_date,
      );
    if (record?.customer_3phase_earthing_status_date)
      record.customer_3phase_earthing_status_date = formatDate(
        record?.customer_3phase_earthing_status_date,
      );
    if (record?.door_supplied_status_date)
      record.door_supplied_status_date = formatDate(
        record?.door_supplied_status_date,
      );
    if (record?.motor_supplied_status_date)
      record.motor_supplied_status_date = formatDate(
        record?.motor_supplied_status_date,
      );
    if (record?.cabin_status_date)
      record.cabin_status_date = formatDate(record?.cabin_status_date);
    if (record?.control_panel_status_date)
      record.control_panel_status_date = formatDate(
        record?.control_panel_status_date,
      );
    if (record?.customer_archive_work_status_date)
      record.customer_archive_work_status_date = formatDate(
        record?.customer_archive_work_status_date,
      );
    if (record?.material_ready_status_date)
      record.material_ready_status_date = formatDate(
        record?.material_ready_status_date,
      );
    if (record?.admin_approval_status_date)
      record.admin_approval_status_date = formatDate(
        record?.admin_approval_status_date,
      );
    if (record?.commissioning_status_date)
      record.commissioning_status_date = formatDate(
        record?.commissioning_status_date,
      );
    if (record?.lost_date) record.lost_date = formatDate(record?.lost_date);

    // handel owner_ids
    record.owner_ids = record.owner_ids
      ?.filter((item) => item.value)
      ?.map((item) => item.value);
    // //========= Logic to perform Create or Edit ======
    if (record.id) {
      // console.log('Updated');
      const result = await fuziElevatorsApi.saveOrder(record);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Update",
          message: "Record updated successfully",
        });
        // navigate(`/contacts/${record?.id}`, { state: record });
        navigate(`${ROUTES.ORDER.LIST}/${record?.id}`, { state: record });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Update Error",
          message: result?.errors,
        });
      }
    } else {
      // console.log('Created');
      const result = await fuziElevatorsApi.createOrder(record);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record created",
          message: "Record created successfully",
        });

        navigate(`${ROUTES.ORDER.LIST}/${result.id}`, { state: result.data });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record Save Error",
          message: result?.errors,
        });
      }
    }
  };

  const handleCancel = () => {
    if (order.id) {
      navigate(`${ROUTES.ORDER.LIST}/${order.id}`, { state: order });
    } else {
      navigate(ROUTES.ORDER.LIST);
    }
  };

  const onOfferSelect = async (id) => {
    const offerData = await fuziElevatorsApi.fetchOfferById(id);
    console.log("offerData", offerData);
    if (offerData) {
      const orderRecord = {};

      // General Info
      orderRecord.lead_id = offerData.lead_id || null;
      orderRecord.lead_name = offerData.lead_name || "";

      orderRecord.email = offerData.email || "";
      orderRecord.phone = offerData.phone || "";
      orderRecord.whatsapp_no = offerData.whatsapp_no || "";
      orderRecord.owner_ids = offerData.owner_ids || [];
      orderRecord.owner_name = offerData.owner_name || "";

      // Order Info
      orderRecord.order_amount = offerData?.highest_model_rate || 0;
      orderRecord.qty = 1;

      // Customer Info
      orderRecord.customer_type = offerData.offer_type || "";
      orderRecord.company_name = offerData.company_name || "";
      orderRecord.sector = offerData.sector || "";
      orderRecord.is_gst = offerData.is_gst || "";
      orderRecord.gst_no = offerData.gst_no || "";
      orderRecord.competitor_name = offerData.competitor_name || "";

      // Material Info
      orderRecord.passenger_capacity = offerData.passenger_capacity || "";
      orderRecord.total_stops = offerData.total_stops || "";
      orderRecord.same_side = offerData.offer_side || "";
      orderRecord.number_of_openings = offerData.number_of_openings || "";
      orderRecord.floor_counts = offerData.floor_counts || "";
      orderRecord.motor = offerData.motor || "";
      orderRecord.lift_speed = offerData.lift_speed || "";
      orderRecord.door_opening = offerData.door_opening || "";
      orderRecord.door_metal = offerData.door_metal || "";
      orderRecord.all_doors_same = offerData.all_doors_same || "";
      orderRecord.different_floor_name = offerData.floor_name || "";
      orderRecord.cabin_metal = offerData.cabin_metal || "";
      orderRecord.door_panels = offerData.door_panels || "";
      orderRecord.door_width = offerData.door_width || "";
      orderRecord.door_height = offerData.door_height || "";
      orderRecord.door_vision = offerData.door_vision || "";
      orderRecord.shaft_width = offerData.shaft_width || "";
      orderRecord.shaft_depth = offerData.shaft_debth || "";
      orderRecord.shaft_construction = offerData.shaft_construction || "";
      orderRecord.machine_room = offerData.machine_room || "";
      orderRecord.dlp_period = offerData.dlp_period || "";
      orderRecord.brand_offered = offerData.brand_offered || "";

      // Address Info
      orderRecord.site_address = offerData.site_address || "";
      orderRecord.state = offerData.state || "";
      orderRecord.city = offerData.city || "";
      orderRecord.office_address = offerData.office_address || "";
      orderRecord.office_city = offerData.office_city || "";
      orderRecord.pincode = offerData.pincode || "";
      orderRecord.country = offerData.country || "";
      orderRecord.area = offerData.area || ""; //Added by shahir hussain 28-01-2026
      orderRecord.segment = offerData.segment || ""; //Added by shahir hussain 02-02-2026

      if (offerData.phone) {
        setErrors((prev) => {
          delete prev["phone"];
          return { ...prev };
        });
      }
      if (offerData?.owner_ids) {
        setErrors((prev) => {
          delete prev["owner_ids"];
          return { ...prev };
        });
      }

      setOrder((prev) => ({ ...prev, ...orderRecord }));
    }
  };
  return (
    <Container className="pb-5">
      {/* Imran khan Update Enquiry Lost Modal Code Here 07-01-2026 */}
      <>
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>REASON OF ORDER LOST</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col lg={12}>
              <Form.Group>
                <Form.Label>Lost Date</Form.Label>
                <Form.Control
                  disabled
                  value={formatDateForCreatedDate(order?.lost_date)}
                />
              </Form.Group>
            </Col>
            <Col lg={12} className="mt-2">
              <Form.Group>
                <Form.Label>Order Lost Reason</Form.Label>
                <Form.Control
                  type="text"
                  name="lost_remark"
                  placeholder="Lost Remark"
                  value={lostOrderData.lost_remark}
                  onChange={handleLostOrderChange}
                />
              </Form.Group>
            </Col>
            <Col lg={12} className="mt-2">
              <Form.Group>
                <Form.Label>Lost By (Company)</Form.Label>
                <Form.Control
                  type="text"
                  name="lost_by_reason"
                  placeholder="Lost By Reason"
                  value={lostOrderData.lost_by_reason}
                  onChange={handleLostOrderChange}
                />
              </Form.Group>
            </Col>

            {/* I will not close if you click outside me. Do not even try to press
                    escape key. */}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleLostOrderSave}>
              Save
            </Button>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            {/* <Button variant="primary">Understood</Button> */}
          </Modal.Footer>
        </Modal>
      </>
      {/* End Here Imran khan Update Enquiry Lost Modal Code Here 07-01-2026 */}
      <Row>
        <Col md={12} className="sticky-breadcrumb">
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.ORDER.LIST)}>
              Order
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col md={12}>
          <Form
            className=""
            onSubmit={() => handleSubmit}
            noValidate
            validated={validated}
          >
            <Card className="shadow">
              <CardHeader className="bg-custom text-white sticky-card-header">
                <Row className="w-100">
                  <Col lg={6} className="">
                    <div className="d-flex align-items-center h-100 gap-3">
                      {order?.id ? (
                        <h5 className="m-0">
                          Edit Order {order?.order_jon_no || ""}
                        </h5>
                      ) : (
                        <h5 className="m-0">Create Order</h5>
                      )}
                    </div>
                  </Col>
                  <Col lg={6} className="p-0">
                    <Stack direction="horizontal" className="float-end" gap={2}>
                      <Button
                        size="sm"
                        className="btn-save"
                        onClick={handleSubmit}
                      >
                        Save
                      </Button>
                      <Button
                        size="sm"
                        className="btn-delete"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                    </Stack>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody className="">
                <Row lg={12} className="view-form ">
                  <>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOffer"
                        >
                          Offer
                        </Form.Label>
                        <div className="d-flex align-items-center gap-2">
                          <div className="flex-grow-1">
                            <Select
                              required
                              className={`${order?.offer_id ? "custom-select-valid" : "custom-select-invalid"}`}
                              placeholder="Select your offer"
                              options={offers?.map((offer) => ({
                                value: offer?.id,
                                label: offer?.name,
                              }))}
                              onChange={(e) => {
                                handleChange({
                                  target: { name: "offer_id", value: e.value },
                                });
                                handleChange({
                                  target: {
                                    name: "offer_name_label",
                                    value: e.label,
                                  },
                                });
                                onOfferSelect(e.value);
                              }}
                              value={
                                order?.offer_id
                                  ? {
                                    value: order?.offer_id,
                                    label: order?.offer_name_label,
                                  }
                                  : ""
                              }
                            />
                          </div>
                          <Button
                            size="sm"
                            variant="success"
                            disabled={!order?.offer_id}
                            onClick={() =>
                              order?.offer_id && onOfferSelect(order?.offer_id)
                            }
                            className="refresh-btn"
                          >
                            <i className="fa fa-refresh"></i>
                          </Button>
                        </div>
                        <Form.Control.Feedback type="invalid">
                          {errors?.offer_id?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicStateLead"
                        >
                          Lead
                        </Form.Label>
                        <Select
                          placeholder="Select your lead"
                          options={leads?.map((lead) => ({
                            value: lead?.id,
                            label: lead?.name,
                          }))}
                          onChange={(e) => {
                            handleChange({
                              target: { name: "lead_id", value: e.value },
                            });
                            handleChange({
                              target: { name: "lead_name", value: e.label },
                            });
                          }}
                          value={
                            order?.lead_id
                              ? {
                                value: order?.lead_id,
                                label: order?.lead_name,
                              }
                              : ""
                          }
                        ></Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.lead_id?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOrderDate"
                        >
                          Order Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="order_date"
                          value={formatDate(order?.order_date)}
                          onChange={handleChange}
                          max={formatDate(new Date())}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.order_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicStatus"
                        >
                          Status
                        </Form.Label>
                        <Form.Select
                          required
                          name="order_status"
                          value={order?.order_status || ""}
                          onChange={handleChange}
                        >
                          <option value="">---select status---</option>
                          {Constant.ORDER_STATUS_VALUES?.map(
                            (status, index) => (
                              <option value={status.label || ""} key={index}>
                                {status.label || ""}
                              </option>
                            ),
                          )}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {errors?.order_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicEmail"
                        >
                          Email
                        </Form.Label>
                        <Form.Control
                          pattern={regExPattern.email}
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={order?.email || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.email?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicPhone"
                        >
                          Phone
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="phone"
                          placeholder="Enter phone"
                          value={order?.phone || ""}
                          onChange={handleChange}
                          maxLength={10}
                          pattern={regExPattern.phone}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.phone?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicPhone"
                        >
                          WhatsApp No.
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="whatsapp_no"
                          placeholder="Enter whatsApp number"
                          value={order?.whatsapp_no || ""}
                          onChange={handleChange}
                          maxLength={10}
                          pattern={regExPattern.phone}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.whatsapp_no?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicOwner"
                                                >
                                                    Assign Staff
                                                </Form.Label>
                                                <Select
                                                    required
                                                    name="owner_ids"
                                                    className={`${order?.owner_ids ? 'custom-select-valid' : 'custom-select-invalid'}`}
                                                    onChange={(e) => {
                                                        handleChange({ target: { name: "owner_ids", value: e.value } });
                                                        handleChange({ target: { name: "owner_name", value: e.label } });
                                                    }}
                                                    options={assignUsers?.map((user) => ({ value: user.id, label: user.username }))}
                                                    value={order?.owner_ids ? { value: order?.owner_ids || "", label: order?.owner_name || "" } : ""}
                                                />
                                                {(errors?.owner_ids?.message && (!order.owner_ids)) && <div className="feedback-invalid">
                                                    {errors?.owner_ids?.message}
                                                </div>}
                                            </Form.Group>
                                        </Col> */}

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicLeadDelegatedUsers"
                        >
                          Assign Users
                        </Form.Label>
                        <Select
                          isMulti
                          placeholder="Select your Assign Staff"
                          className={`${Array.isArray(order?.owner_ids) && order?.owner_ids?.length > 0 ? "custom-select-valid" : "custom-select-invalid"}`}
                          options={assignUsers?.map((item) => ({
                            value: item.id,
                            label: item.username,
                          }))}
                          value={order?.owner_ids?.filter((item) => item.value)}
                          onChange={(e) => {
                            handleChange({
                              target: { name: "owner_ids", value: e },
                            });
                          }}
                        />
                        {errors?.owner_ids?.message && validated && (
                          <div className="feedback-invalid">
                            {errors?.owner_ids?.message}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    <Col md={12} className="section-header">
                      Customer Information
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCustomerType"
                        >
                          Customer Type
                        </Form.Label>
                        <FormSelect
                          name="customer_type"
                          value={order?.customer_type || ""}
                          onChange={handleChange}
                        >
                          <option value={""}>--select type--</option>
                          <option value={"Individual"}>Individual</option>
                          <option value={"Corporate"}>Corporate</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_type?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {order?.customer_type == "Corporate" && (
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label>Company Name</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter company name"
                            name="company_name"
                            value={order?.company_name || ""}
                            // onChange={handleChange}
                            onChange={(e) =>
                              handleUppercaseChange(e, handleChange)
                            }
                          />
                        </Form.Group>
                      </Col>
                    )}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicSector "
                        >
                          Sector
                        </Form.Label>
                        <Form.Select
                          name="sector"
                          value={order?.sector || ""}
                          onChange={handleChange}
                        >
                          <option value="">---select sector---</option>
                          {[
                            "Government site",
                            "Customer is private",
                            "Government customer direct with us",
                          ].map((item, index) => (
                            <option value={item} key={index}>
                              {item}
                            </option>
                          ))}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {errors?.sector?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicIsGst"
                        >
                          Is GST Applicable
                        </Form.Label>
                        <FormSelect
                          name="is_gst"
                          value={order?.is_gst || ""}
                          onChange={handleChange}
                        >
                          <option value={""}>--select--</option>
                          <option value={"Yes"}>Yes</option>
                          <option value={"No"}>No</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.is_gst?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {order?.is_gst === "Yes" && (
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label>GST Number</Form.Label>
                          <Form.Control
                            type="text"
                            placeholder="Enter gst number"
                            name="gst_no"
                            value={order?.gst_no?.toUpperCase() || ""}
                            // onChange={handleChange}
                            onChange={(e) => {
                              const value = e.target.value;
                              setOrder((prev) => ({
                                ...prev,
                                gst_no: value.replace(/\s+/g, "").toUpperCase(),
                              }));
                            }}
                          />
                        </Form.Group>
                        <Form.Control.Feedback type="invalid">
                          {errors?.gst_no?.message}
                        </Form.Control.Feedback>
                      </Col>
                    )}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompetitorName "
                        >
                          Competitor Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="competitor_name"
                          placeholder="Enter competitor name"
                          value={order?.competitor_name || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                          pattern={regExPattern.name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.competitor_name?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* //Added by shahir hussain for segment type field 02-02-2025 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Segment Type
                        </Form.Label>

                        <Select
                          isMulti
                          placeholder="Select Segment Type"
                          options={segmentOptions}
                          value={
                            typeof order?.segment === "string" && order?.segment
                              ? segmentOptions?.filter((opt) =>
                                order?.segment?.split(",").includes(opt?.value),
                              )
                              : []
                          }
                          onChange={(selectedOptions) => {
                            handleChange({
                              target: {
                                name: "segment",
                                value: selectedOptions,
                              },
                            });
                          }}
                        // className={
                        //   order?.segment && order?.segment?.length > 0
                        //     ? "custom-select-valid"
                        //     : "custom-select-invalid"
                        // }
                        />

                        {errors?.segment?.message && validated && (
                          <div className="feedback-invalid">
                            {errors?.segment?.message}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    {/*Imran Khan Updated 15/01/2026 Quantity Defult*/}
                    <Col md={12} className="section-header">
                      Order Information
                    </Col>
                    {/* Amount Information */}
                    {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_PAYMENT].some(
                      (permission) => {
                        return userInfo?.permissions
                          ?.map((p) => p.name)
                          .includes(permission);
                      },
                    ) && (
                        <>
                          <Col lg={6}>
                            <Form.Group>
                              <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicOrderDate"
                              >
                                Order Value
                              </Form.Label>
                              <Form.Control
                                disabled
                                type="number"
                                onKeyDownCapture={(e) =>
                                  ["e", "E", "+", "-"].includes(e.key) &&
                                  e.preventDefault()
                                }
                                name="order_amount"
                                value={order?.order_amount || ""}
                                onChange={handleChange}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors?.order_amount?.message}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col lg={6}>
                            <Form.Group>
                              <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicQuantity"
                              >
                                Quantity
                              </Form.Label>
                              <Form.Control
                                type="number"
                                name="qty"
                                value={order.qty}
                                disabled
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors?.qty?.message}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>

                          {/* Commented by shahir hussain 13-06-2025*/}
                          {/* <Col lg={6}>
                                            <Form.Group
                                            >
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicBasicAmountValue"
                                                >
                                                    Basic Amount Value
                                                </Form.Label>
                                                <Form.Control
                                                    placeholder="Enter basic amount"
                                                    type="number"
                                                    onKeyDownCapture={e => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                    name="basic_amount"
                                                    value={order?.basic_amount || ''}
                                                    onChange={handleChange}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.basic_amount?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col> */}
                          {/* New Fields Added As Per Client Requiment */}
                          <Col lg={6}>
                            <Form.Group>
                              <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicOrderDate"
                              >
                                Cheque Amount
                              </Form.Label>
                              <Form.Control
                                placeholder="Enter cheque amount"
                                type="number"
                                onKeyDownCapture={(e) =>
                                  ["e", "E", "+", "-"].includes(e.key) &&
                                  e.preventDefault()
                                }
                                name="cheque_amount"
                                value={order?.cheque_amount || ""}
                                onChange={handleChange}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors?.cheque_amount?.message}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col lg={6}>
                            <Form.Group>
                              <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicOrderDate"
                              >
                                Cash Amount
                              </Form.Label>
                              <Form.Control
                                placeholder="Enter cash amount"
                                type="number"
                                onKeyDownCapture={(e) =>
                                  ["e", "E", "+", "-"].includes(e.key) &&
                                  e.preventDefault()
                                }
                                name="cash_amount"
                                value={order?.cash_amount || ""}
                                onChange={handleChange}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors?.cheque_amount?.message}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col lg={6}>
                            <Form.Group>
                              <Form.Label
                                className="form-view-label"
                                htmlFor="formBasicTPC"
                              >
                                TPC
                              </Form.Label>
                              <Form.Control
                                placeholder="Enter tpc"
                                type="number"
                                onKeyDownCapture={(e) =>
                                  ["e", "E", "+", "-"].includes(e.key) &&
                                  e.preventDefault()
                                }
                                name="tpc_amount"
                                value={order?.tpc_amount || ""}
                                onChange={handleChange}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors?.tpc_amount?.message}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </>
                      )}
                    {/* End Here */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicBuildingLocation"
                        >
                          Building Location
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="building_location"
                          placeholder="Enter building location"
                          value={order?.building_location || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.building_location?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicWarrantyUpto"
                        >
                          Warranty Period
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="warranty_upto"
                          placeholder="Enter warranty upto"
                          value={order?.warranty_upto || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.warranty_upto?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicHandoverDate"
                        >
                          Handover Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="handover_date"
                          value={formatDate(order.handover_date || "")}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.handover_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* <Col lg={6}>
                                            <Form.Group>
                                                <Form.Label
                                                    className="form-view-label"
                                                    htmlFor="formBasicWarrantyStartDate"
                                                >
                                                    Warranty Start Date
                                                </Form.Label>
                                                <Form.Control
                                                    type="date"
                                                    name="warranty_start_date"
                                                    value={formatDate(order.warranty_start_date || "")}
                                                    onChange={handleChange}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors?.warranty_start_date?.message}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </Col> */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicWarrantyEndDate"
                        >
                          Warranty Upto
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="warranty_end_date"
                          value={formatDate(order.warranty_end_date || "")}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.warranty_end_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    <Col md={12} className="section-header">
                      GAD Information
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicIsGst"
                        >
                          GAD Status
                        </Form.Label>
                        <FormSelect
                          name="gad_status"
                          value={order?.gad_status || ""}
                          onChange={handleChange}
                        >
                          {["Pending", "Complete"]?.map((item) => (
                            <option value={item}>{item}</option>
                          ))}
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.gad_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicGADAllowedTo"
                        >
                          GAD Allowed To
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="gad_allowed_to"
                          value={formatDate(order.gad_allowed_to || "")}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.gad_allowed_to?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicGADFinalizedOn"
                        >
                          GAD Finalized On
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="gad_finalized_on"
                          value={formatDate(order.gad_finalized_on || "")}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.gad_finalized_on?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={12} className="section-header">
                      Material Allotment Information
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicScaffoldingMaterialStatus"}
                        >
                          Scaffolding Material Status
                        </Form.Label>
                        <FormSelect
                          name="scaffolding_material_status"
                          value={order?.scaffolding_material_status || ""}
                          onChange={handleChange}
                        >
                          <option value={"Pending"}>Pending</option>
                          <option value={"Complete"}>Complete</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.scaffolding_material_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicScaffoldingMaterialStatusDate"}
                        >
                          Scaffolding Material Status Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="scaffolding_material_status_date"
                          value={formatDate(
                            order?.scaffolding_material_status_date || "",
                          )}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.scaffolding_material_status_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCustomerWhiteWashStatus"}
                        >
                          Customer White Wash Status
                        </Form.Label>
                        <FormSelect
                          name="customer_white_wash_status"
                          value={order?.customer_white_wash_status || ""}
                          onChange={handleChange}
                        >
                          <option value={"Pending"}>Pending</option>
                          <option value={"Complete"}>Complete</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_white_wash_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCustomerWhiteWashStatusDate"}
                        >
                          Customer White Wash Status Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="customer_white_wash_status_date"
                          value={formatDate(
                            order?.customer_white_wash_status_date || "",
                          )}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_white_wash_status_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCustomerShaftLightingStatus"}
                        >
                          Customer Shaft Lighting Status
                        </Form.Label>
                        <FormSelect
                          name="customer_shaft_lighting_status"
                          value={order?.customer_shaft_lighting_status || ""}
                          onChange={handleChange}
                        >
                          <option value={"Pending"}>Pending</option>
                          <option value={"Complete"}>Complete</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_shaft_lighting_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCustomerShaftLightingStatusDate"}
                        >
                          Customer Shaft Lighting Status Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="customer_shaft_lighting_status_date"
                          value={formatDate(
                            order?.customer_shaft_lighting_status_date || "",
                          )}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_shaft_lighting_status_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCustomer3phaseEarthingStatus"}
                        >
                          Customer 3phase Earthing Status
                        </Form.Label>
                        <FormSelect
                          name="customer_3phase_earthing_status"
                          value={order?.customer_3phase_earthing_status || ""}
                          onChange={handleChange}
                        >
                          <option value={"Pending"}>Pending</option>
                          <option value={"Complete"}>Complete</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_3phase_earthing_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCustomer3phaseEarthingStatusDate"}
                        >
                          Customer 3phase Earthing Status Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="customer_3phase_earthing_status_date"
                          value={formatDate(
                            order?.customer_3phase_earthing_status_date || "",
                          )}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {
                            errors?.customer_3phase_earthing_status_date
                              ?.message
                          }
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDoorSuppliedStatus"}
                        >
                          Door Supplied Status
                        </Form.Label>
                        <FormSelect
                          name="door_supplied_status"
                          value={order?.door_supplied_status || ""}
                          onChange={handleChange}
                        >
                          <option value={"Pending"}>Pending</option>
                          <option value={"Complete"}>Complete</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.door_supplied_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDoorSuppliedStatusDate"}
                        >
                          Door Supplied Status Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="door_supplied_status_date"
                          value={formatDate(
                            order?.door_supplied_status_date || "",
                          )}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.door_supplied_status_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicMotorSuppliedStatus"}
                        >
                          Motor Supplied Status
                        </Form.Label>
                        <FormSelect
                          name="motor_supplied_status"
                          value={order?.motor_supplied_status || ""}
                          onChange={handleChange}
                        >
                          <option value={"Pending"}>Pending</option>
                          <option value={"Complete"}>Complete</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.motor_supplied_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicMotorSuppliedStatusDate"}
                        >
                          Motor Supplied Status Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="motor_supplied_status_date"
                          value={formatDate(
                            order?.motor_supplied_status_date || "",
                          )}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.motor_supplied_status_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCabinStatus"}
                        >
                          Cabin Status
                        </Form.Label>
                        <FormSelect
                          name="cabin_status"
                          value={order?.cabin_status || ""}
                          onChange={handleChange}
                        >
                          <option value={"Pending"}>Pending</option>
                          <option value={"Complete"}>Complete</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.cabin_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCabinStatusDate"}
                        >
                          Cabin Status Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="cabin_status_date"
                          value={formatDate(order?.cabin_status_date || "")}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.cabin_status_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicControlPanelStatus"}
                        >
                          Control Panel Status
                        </Form.Label>
                        <FormSelect
                          name="control_panel_status"
                          value={order?.control_panel_status || ""}
                          onChange={handleChange}
                        >
                          <option value={"Pending"}>Pending</option>
                          <option value={"Complete"}>Complete</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.control_panel_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicControlPanelStatusDate"}
                        >
                          Control Panel Status Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="control_panel_status_date"
                          value={formatDate(
                            order?.control_panel_status_date || "",
                          )}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.control_panel_status_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCustomerArchiveWorkStatus"}
                        >
                          Customer Archive Work Status
                        </Form.Label>
                        <FormSelect
                          name="customer_archive_work_status"
                          value={order?.customer_archive_work_status || ""}
                          onChange={handleChange}
                        >
                          <option value={"Pending"}>Pending</option>
                          <option value={"Complete"}>Complete</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_archive_work_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCustomerArchiveWorkStatusDate"}
                        >
                          Customer Archive Work Status Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="customer_archive_work_status_date"
                          value={formatDate(
                            order?.customer_archive_work_status_date || "",
                          )}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_archive_work_status_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicMaterialReadyStatus"}
                        >
                          Material Ready Status
                        </Form.Label>
                        <FormSelect
                          name="material_ready_status"
                          value={order?.material_ready_status || ""}
                          onChange={handleChange}
                        >
                          <option value={"Pending"}>Pending</option>
                          <option value={"Complete"}>Complete</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.material_ready_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicMaterialReadyStatusDate"}
                        >
                          Material Ready Status Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="material_ready_status_date"
                          value={formatDate(
                            order?.material_ready_status_date || "",
                          )}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.material_ready_status_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicAdminApprovalStatus"}
                        >
                          Admin Approval Status
                        </Form.Label>
                        <FormSelect
                          name="admin_approval_status"
                          value={order?.admin_approval_status || ""}
                          onChange={handleChange}
                        >
                          <option value={"Pending"}>Pending</option>
                          <option value={"Complete"}>Complete</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.admin_approval_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicAdminApprovalStatusDate"}
                        >
                          Admin Approval Status Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="admin_approval_status_date"
                          value={formatDate(
                            order?.admin_approval_status_date || "",
                          )}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.admin_approval_status_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCommissioningStatus"}
                        >
                          Commissioning Status
                        </Form.Label>
                        <FormSelect
                          name="commissioning_status"
                          value={order?.commissioning_status || ""}
                          onChange={handleChange}
                        >
                          <option value={"Pending"}>Pending</option>
                          <option value={"Complete"}>Complete</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.commissioning_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCommissioningStatusDate"}
                        >
                          Commissioning Status Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="commissioning_status_date"
                          value={formatDate(
                            order?.commissioning_status_date || "",
                          )}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.commissioning_status_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col md={12} className="section-header">
                      Material Information
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicPassengerCapacity"}
                        >
                          Passenger Capacity
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="passenger_capacity"
                          placeholder="Enter passenger capacity"
                          value={order?.passenger_capacity || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.passenger_capacity?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicTotalStops"}
                        >
                          Total Number Of Stops
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="total_stops"
                          placeholder="Enter total stops"
                          value={order?.total_stops || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.total_stops?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicSameSide"}
                        >
                          Same Side
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="same_side"
                          placeholder="Enter same side"
                          value={order?.same_side || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.same_side?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicNumberOfOpenings"}
                        >
                          Number Of Openings
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="number_of_openings"
                          placeholder="Enter number of openings"
                          value={order?.number_of_openings || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.number_of_openings?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicFloorCounts"}
                        >
                          Floor Counts
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="floor_counts"
                          placeholder="Enter floor counts"
                          value={order?.floor_counts || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.floor_counts?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicMotor"}
                        >
                          Motor
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="motor"
                          placeholder="Enter motor"
                          value={order?.motor || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.motor?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicMotorMake"}
                        >
                          Motor Make
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="motor_make"
                          placeholder="Enter motor make"
                          value={order?.motor_make || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.motor_make?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicControllerMake"}
                        >
                          Controller Make
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="controller_make"
                          placeholder="Enter controller make"
                          value={order?.controller_make || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.controller_make?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicLiftSpeed"}
                        >
                          Lift Speed
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="lift_speed"
                          placeholder="Enter lift speed"
                          value={order?.lift_speed || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.lift_speed?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDoorOpening"}
                        >
                          Door Opening
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_opening"
                          placeholder="Enter door opening"
                          value={order?.door_opening || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.door_opening?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDoorMake"}
                        >
                          Door Make
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_make"
                          placeholder="Enter door make"
                          value={order?.door_make || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.door_make?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDoorMetal"}
                        >
                          Door Metal
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_metal"
                          placeholder="Enter door metal"
                          value={order?.door_metal || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.door_metal?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicAllDoorsSame"}
                        >
                          All Doors Same
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="all_doors_same"
                          placeholder="Enter all doors same"
                          value={order?.all_doors_same || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.all_doors_same?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDifferentFloorName"}
                        >
                          Different Floor Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="different_floor_name"
                          placeholder="Enter different floor name"
                          value={order?.different_floor_name || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.different_floor_name?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicCabinMetal"}
                        >
                          Cabin Metal
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="cabin_metal"
                          placeholder="Enter cabin metal"
                          value={order?.cabin_metal || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.cabin_metal?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDoorPanels"}
                        >
                          Door Panels
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_panels"
                          placeholder="Enter door panels"
                          value={order?.door_panels || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.door_panels?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDoorWidth"}
                        >
                          Door Width
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_width"
                          placeholder="Enter door width"
                          value={order?.door_width || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.door_width?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDoorHeight"}
                        >
                          Door Height
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_height"
                          placeholder="Enter door height"
                          value={order?.door_height || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.door_height?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDoorVision"}
                        >
                          Door Vision
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="door_vision"
                          placeholder="Enter door vision"
                          value={order?.door_vision || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.door_vision?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicShaftWidth"}
                        >
                          Shaft Width
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="shaft_width"
                          placeholder="Enter shaft width"
                          value={order?.shaft_width || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.shaft_width?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicShaftDepth"}
                        >
                          Shaft Depth
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="shaft_depth"
                          placeholder="Enter shaft depth"
                          value={order?.shaft_depth || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.shaft_depth?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicShaftConstruction"}
                        >
                          Shaft Construction
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="shaft_construction"
                          placeholder="Enter shaft construction"
                          value={order?.shaft_construction || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.shaft_construction?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicMachineRoom"}
                        >
                          Machine Room
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="machine_room"
                          placeholder="Enter machine room"
                          value={order?.machine_room || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.machine_room?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicDlpPeriod"}
                        >
                          Dlp Period
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="dlp_period"
                          placeholder="Enter dlp period"
                          value={order?.dlp_period || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.dlp_period?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicBrandOffered"}
                        >
                          Brand Offered
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="brand_offered"
                          placeholder="Enter brand offered"
                          value={order?.brand_offered || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.brand_offered?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor={"formBasicSpecialRequest"}
                        >
                          Special Request
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="special_request"
                          placeholder="Enter special request"
                          value={order?.special_request || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.special_request?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    <Col md={12} className="section-header">
                      Address Information
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicSiteAddress"
                        >
                          Site Address
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="site_address"
                          placeholder="Enter site address"
                          value={order?.site_address || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.site_address?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* //Added by shahir hussain */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicArea"
                        >
                          Area
                        </Form.Label>
                        <Form.Control
                          pattern={regExPattern.name}
                          type="text"
                          name="area"
                          placeholder="Enter area name"
                          value={order?.area || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.area?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicState"
                        >
                          State
                        </Form.Label>

                        <Select
                          placeholder="Select your state"
                          options={states?.map((state) => ({
                            value: state,
                            label: state,
                          }))}
                          onChange={(e) => {
                            setOrder((prev) => ({ ...prev, city: "" }));
                            handleChange({
                              target: { name: "state", value: e.value },
                            });
                          }}
                          value={
                            order?.state
                              ? {
                                value: order?.state || "",
                                label: order?.state || "",
                              }
                              : ""
                          }
                        ></Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.state?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCity"
                        >
                          City
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="city"
                          placeholder="Enter city"
                          value={order?.city || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.city?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOfficeAddress"
                        >
                          Office Address
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="office_address"
                          placeholder="Enter office address"
                          value={order?.office_address || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.office_address?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOfficeCity"
                        >
                          Office City
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="office_city"
                          placeholder="Enter office city"
                          value={order?.office_city || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.office_city?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicPin"
                        >
                          Pincode
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="pincode"
                          placeholder="Enter pincode"
                          value={order?.pincode || ""}
                          onChange={handleChange}
                          pattern={regExPattern.pinCode}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.pincode?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCountry"
                        >
                          Country
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="country"
                          placeholder="Enter country"
                          value={order?.country || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                          pattern={regExPattern.name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.country?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </>
                </Row>
              </CardBody>
            </Card>
          </Form>
        </Col>
      </Row>
      <Modal show={showLostModal}>
        <Modal.Header>
          <Modal.Title>REASON OF ORDER LOST</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Col lg={12}>
            <Form.Group>
              <Form.Label>Lost Date</Form.Label>
              <Form.Control
                disabled
                value={formatDateForView(order.lost_date)}
              />
            </Form.Group>
          </Col>
          <Col lg={12}>
            <Form.Group>
              <Form.Label>Reason</Form.Label>
              <Form.Control
                type="text"
                name="lost_remark"
                placeholder="Enter reason"
                value={order?.lost_remark || ""}
                onChange={handleChange}
              // pattern={regExPattern.name}
              />
            </Form.Group>
          </Col>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            disabled={!order?.lost_remark}
            onClick={() => setShowLostModal(false)}
          >
            Done
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default OrderEdit;
